import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { STUDIO_INQUIRY_STEPS } from '../../constants/common';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-studio-inquiry-sidebar',
    templateUrl: './studio-inquiry-sidebar.component.html',
    styleUrls: ['./studio-inquiry-sidebar.component.scss'],
    standalone: false
})
export class StudioInquirySidebarComponent {
  /** Zero based index of the step being filled in */
  @Input() activeStep: number = 0;
  constants = STUDIO_INQUIRY_STEPS;
}
